import styled from 'styled-components';

import { Flex, VFlex } from '@/components/base';
import ScrollView from '@/components/Common/ScrollView';
import Portal from '@/components/Portal/Portal';
import Typo from '@/components/Typography/Typo';
import Label from '@/features/Feedback/field/Tag/Label';
import useColor from '@/hooks/domain/useColor';
import useTagStore from '@/stores/TagStore';
import { modalStyle } from '@/styles/style';
import zIndex from '@/styles/zIndex';
import feedbackUtils from '@/utils/feedback';

interface Props {
  selectedTags?: string[];
  style?: any;
  closeModal?: () => void;
}

const TagSelectedModal = ({ selectedTags, style }: Props) => {
  const color = useColor();
  const { tagMap } = useTagStore((state) => ({ tagMap: state.tagMap }));

  return (
    <Portal id="modal-layer">
      <Wrapper style={style}>
        <Flex>
          <Typo type="body3" color={color.gray700}>
            Selected
          </Typo>
        </Flex>
        <ScrollView style={{ maxHeight: 320 }}>
          {selectedTags
            ?.filter((key) => tagMap[key])
            .map((key: string) => {
              const tag = tagMap[key];
              const tagHTML = feedbackUtils.getTagHTML(tagMap, key);

              return (
                <VFlex
                  key={tag.alias}
                  a="flex-start"
                  g={8}
                  style={{ marginTop: 8 }}
                >
                  <Label
                    themeColor={tag.color}
                    text={
                      <span
                        dangerouslySetInnerHTML={{
                          __html: tagHTML,
                        }}
                      ></span>
                    }
                    isSelected={false}
                    // withoutBorder
                    // onClick={toggleTagSelectModal}
                  />
                </VFlex>
              );
            })}
        </ScrollView>
      </Wrapper>
    </Portal>
  );
};

const Wrapper = styled(VFlex)`
  position: fixed;
  min-width: 168px;
  ${modalStyle};
  padding: 12px 16px;
  z-index: ${zIndex.dropdown};
  .label-wrapper {
    padding: 24px;
  }
`;

export default TagSelectedModal;
